import React from 'react';
import { ProfileState, initialState } from './state';
import { ProfileActions } from './actions';

export const ProfileContext = React.createContext<{
  state: ProfileState;
  dispatch: React.Dispatch<ProfileActions>;
}>({
  state: initialState,
  dispatch: () => undefined,
});